<template>
    <div>
        <b-modal
            id="previewModal"
            ref="previewModal"
            @shown="shown"
            :title="title"
            :lazy="true"
            :scrollable="true"
            title-tag="h2"
            dialog-class="preview"
            no-stacking
            footer-class="px-2"
        >
            <!-- Modal Form -->
            <list
                :data="appointment_data"
                v-on="$listeners"
                ref="appointmentList"
                module="modal"
                @updated="onUpdated"
                @update-previsit="id => handleUpdatePrevisit(id)"
            />
            <div slot="modal-footer" v-if="loading" class="float-right">
                <img src="assets/ajax-loader.gif" />
            </div>
            <footer-button
                slot="modal-footer"
                :data="appointment_data"
                v-if="showFooter && !loading"
                v-on="$listeners"
            />
        </b-modal>

        <ModalDialog
            v-if="appointment_data && appointment_data.id"
            ref="modalConfirmationDialog"
            @confirm-dialog="onConfirmUpdateMedicalNote"
            confirmBtnTxt="Confirm"
            :z-index="1045"
        >
            <template #title>Change Medical Note</template>
            <template #body>
                Are you sure you want to permanently change to the new medical
                note, along with its associated records and documents?
            </template>
        </ModalDialog>
    </div>
</template>
<script>
import List from "./list";
import FooterButton from "./footer.vue";
import ScheduleHelper from "@/module/schedule/helper";
import ModalDialog from "@/components/commons/modal-dialog";
export default {
    components: {
        List,
        FooterButton,
        ModalDialog
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            appointment_data: {},
            showFooter: false,
            loading: false
        };
    },
    props: {
        showLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        title() {
            if (this.end.isValid() && this.start.isValid()) {
                return this.start
                    ? moment(this.start).format("h:mm a") +
                          " - " +
                          this.end.format("h:mm a")
                    : "";
            }
            return "";
        },
        start() {
            return moment(this.appointment_data.start);
        },
        end() {
            return moment(this.appointment_data.end);
        }
    },
    watch: {
        showLoading(value) {
            this.loading = value;
        }
    },
    mounted() {
        this.$root.$on("appointment:preview:loading", flag => {
            this.loading = !!flag;
        });
    },
    methods: {
        open(event) {
            this.loading = true;
            this.appointment_data = event;
            this.getData(event.id);
            this.$refs.previewModal.show();
        },
        shown() {},
        getData(id) {
            let self = this;
            self._getAppointment(id).then(response => {
                response.start = moment(
                    !self.appointment_data.fromLink
                        ? self.appointment_data.start
                        : response.start
                ).tz(this._timeZone);
                response.end = moment(
                    !self.appointment_data.fromLink
                        ? self.appointment_data.end
                        : response.end
                ).tz(this._timeZone);
                self.appointment_data = _.assign(
                    response,
                    self.appointment_data
                );

                self.showFooter = true;

                if (
                    self.appointment_data.appointmentStatus.id ==
                    this.APPOINTMENT.STATUS_IN_ROOM
                ) {
                    this.getStatusName();
                }

                self.loading = false;
                self.$root.$emit("bv::hide::popover");
            });
        },
        async getStatusName() {
            let self = this;
            let response = await this.$http.get(
                process.env.SCHEDULE_SERVICE +
                    "room/" +
                    self.appointment_data.appointmentStatus.pivot.room_id
            );

            if (response) {
                if (response.data.response.message.code == 200) {
                    self.appointment_data.appointmentStatus.value =
                        "In " + response.data.response.resources.name;
                }
            }
            return response;
        },
        onConfirmUpdateMedicalNote() {
            this.$refs.appointmentList.updateMedicalNote();
            this.$refs.modalConfirmationDialog.close();
        },
        onUpdated(appointmentId) {
            this.$root.$emit(
                "schedule::appointment::modal::list::updated",
                appointmentId
            );
        },
        async handleUpdatePrevisit(id) {
            let self = this;

            const response = await self._getAppointment(id);

            // Only update pre-visit related data
            if (response) {
                self.appointment_data.pre_visit_send = response.pre_visit_send;
                self.appointment_data.pre_visit_send_at =
                    response.pre_visit_send_at;
            }
        }
    }
};
</script>
